// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__-brgN","column":"style_column__U-2sY","hide":"style_hide__ePg8n","position":"style_position__vDnKc"};